import { axiosGet } from "../../react_axios/Axios";
import { GET_NOTIFICATION_LIST_ACTION_TYPE, getNotificationUrl, READ_NOTIFICATION_ACTION_TYPE, readNotificationUrl, getNotificationPreviewUrl, getTaskNotificationUrl, readTaskNotificationUrl, getTaskNotificationPreviewUrl, headers } from "../../utils/constants";

export const getNotification_action = () => async (dispatch) => {
    try {
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
        const roleID = sessionStorage.getItem('RoleIDSS');
        const recipientID = roleID == 1 ? sessionStorage.getItem('ExhRegistrationIDSS') :
            roleID == 3 ? sessionStorage.getItem('currentVisitorID') :
                sessionStorage.getItem('AccountIDSS');
        const params = {
            UserID: loginData.UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            RecipientID: recipientID,
            RoleName: loginData.RoleName,
        };
        const res = await axiosGet(getNotificationUrl, params, headers);
        dispatch({
            type: GET_NOTIFICATION_LIST_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getNotificationPreview_action = (feaIntimationRecipientID) => async () => {
    try {
        const res = await axiosGet(getNotificationPreviewUrl, {
            FeaIntimationRecipientID: feaIntimationRecipientID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

// ── task notifications ───────────────────────────────────────────────────────
// Keyed on the signed in user rather than on a role plus an account id - a task
// notification is raised for a person, and the row already knows which one

export const getTaskNotification_action = () => async () => {
    try {
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
        const params = {
            UserID: loginData.UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        };
        const res = await axiosGet(getTaskNotificationUrl, params, headers);

        // axiosGet catches every transport error and returns null, so a 404 from a
        // route that was never deployed, a 500 from the procedure, and an empty
        // inbox all look identical to the caller. Say which one it was - without
        // this the bell just sits there silently showing nothing.
        if (res == null) {
            console.warn(
                '[task notifications] NO RESPONSE from', getTaskNotificationUrl,
                '| params', params,
                '| the endpoint is unreachable (route not deployed?) or it errored',
            );
        } else if (res.error == 1) {
            console.warn('[task notifications] API returned an error:', res.msg, res.errormsg || '');
        } else {
            console.log(
                '[task notifications]', (res.data || []).length,
                'row(s) for UserID', params.UserID,
            );
        }

        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getTaskNotificationPreview_action = (recipientID) => async () => {
    try {
        const res = await axiosGet(getTaskNotificationPreviewUrl, {
            VendorTaskNotificationRecipientID: recipientID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }, headers);
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

// No recipient id marks every unread task notification of this user as read
export const readTaskNotification_action = (recipientID) => async () => {
    try {
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
        const params = {
            UserID: loginData.UserID,
            VendorTaskNotificationRecipientID: recipientID ?? '',
        };
        const res = await axiosGet(readTaskNotificationUrl, params, headers);
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const readNotification_action = (IntimationNotificationID) => async (dispatch) => {
    try {
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
        const params = {
            UserID: loginData.UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            IntimationNotificationID:IntimationNotificationID
        };
        const res = await axiosGet(readNotificationUrl, params, headers);
        dispatch({
            type: READ_NOTIFICATION_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};
